import React from 'react'
import { Box } from '../../layout/Box'
import Input from '../../layout/Input'
import { isLeapYear } from '../../../utils/date'

type DateSelectProps = {
  onDayChange: (e: string) => void
  onMonthChange: (e: string) => void
  onYearChange: (e: string) => void
}

export const DateSelect: React.FC<DateSelectProps> = ({ onDayChange, onMonthChange, onYearChange }) => {
  const [selectedDay, setSelectedDay] = React.useState<string | null>(null)
  const [selectedMonth, setSelectedMonth] = React.useState<string | null>(null)
  const [selectedYear, setSelectedYear] = React.useState<string | null>(null)
  const MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31] // index => month [0-11]

  const handleDayChange = (day: string) => {
    setSelectedDay(day)

    onDayChange(day)
  }

  const handleMonthChange = (month: string) => {
    setSelectedMonth(month)

    if (parseInt(selectedDay || '0', 10) > MONTH_DAYS[parseInt(month, 10)]) {
      handleDayChange('1')
    }

    onMonthChange(month)
  }

  const handleYearChange = (year: string) => {
    if (isLeapYear(year)) {
      MONTH_DAYS[1] = 29
    } else {
      MONTH_DAYS[1] = 28
    }
    setSelectedYear(year)
    onYearChange(year)
  }

  const getYearsFromTodayTo1930 = () => {
    const currentYear = new Date().getFullYear()
    const years = []

    for (let i = currentYear; i >= 1930; i -= 1) {
      years.push(i)
    }

    return years
  }

  return (
    <Box flex spaceBetween>
      <Input type="select" name="day" label="Tag" value={selectedDay || ''} onChange={handleDayChange}>
        {Array.from({ length: MONTH_DAYS[parseInt(selectedMonth || '0', 10)] }, (_, i) => i + 1).map(day => (
          <option value={day} key={day}>
            {day}
          </option>
        ))}
      </Input>

      <Input type="select" value={selectedMonth || ''} name="month" label="Monat" onChange={handleMonthChange}>
        <option value={0}>Januar</option>
        <option value={1}>Februar</option>
        <option value={2}>März</option>
        <option value={3}>April</option>
        <option value={4}>May</option>
        <option value={5}>Juni</option>
        <option value={6}>Juli</option>
        <option value={7}>August</option>
        <option value={8}>September</option>
        <option value={9}>Oktober</option>
        <option value={10}>November</option>
        <option value={11}>Dezember</option>
      </Input>

      <Input type="select" value={selectedYear || ''} name="year" label="Jahr" onChange={handleYearChange}>
        {getYearsFromTodayTo1930().map(year => (
          <option value={year} key={year}>
            {year}
          </option>
        ))}
      </Input>
    </Box>
  )
}
